var _ellipse, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDliuthuthp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.075,
    cy: 27.3701,
    rx: 26.5506,
    ry: 26.5498,
    fill: "#6A01FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.0195,
    y: 13.3125,
    width: 28.1124,
    height: 28.1116,
    rx: 3.59216,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2031,
    y: 15.4766,
    width: 3.60415,
    height: 23.7867,
    rx: 1.80207,
    fill: "#6A01FE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3447,
    y: 25.5625,
    width: 3.60415,
    height: 13.6954,
    rx: 1.80207,
    fill: "#6A01FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2734,
    y: 21.2422,
    width: 3.60415,
    height: 18.0202,
    rx: 1.80207,
    fill: "#6A01FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDliuthuthp);
export default __webpack_public_path__ + "static/media/dữ liệu thu thập.0c70574e3b35e82f2391e1298999e9cd.svg";
export { ForwardRef as ReactComponent };